import React from "react";
import { Link, Route, Routes } from "react-router-dom";

import AppShell from "./components/layout/AppShell";
import PremiumLayout from "./components/PremiumLayout";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ContactSubmissionsPage from "./pages/ContactSubmissionsPage";
import CreateOrderPage from "./pages/CreateOrderPage";
import CustomersPage from "./pages/CustomersPage";
import DashboardPage from "./pages/DashboardPage";
import EmployeesPage from "./pages/EmployeesPage";
import EditTaskPage from "./pages/EditTaskPage";
import ExpensesPage from "./pages/ExpensesPage";
import ExpenseHistoryPage from "./pages/ExpenseHistoryPage";
import GalleryPage from "./pages/GalleryPage";
import HomePage from "./pages/HomePage";
import NewHomePage from "./pages/NewHomePage";
import LoginPage from "./pages/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import OrdersPage from "./pages/OrdersPage";
import PaymentsPage from "./pages/PaymentsPage";
import PublicGalleryPage from "./pages/PublicGalleryPage";
import ReportsPage from "./pages/ReportsPage";
import ServicesPage from "./pages/ServicesPage";
import StockPage from "./pages/StockPage";
import TasksPage from "./pages/TasksPage";
import TodoPage from "./pages/TodoPage";

function App() {
  return (
    <Routes>
      {/* NewHomePage has its own header/footer, don't wrap in PremiumLayout */}
      <Route path="/" element={<NewHomePage />} />
      
      {/* Other public pages use PremiumLayout */}
      <Route path="/about" element={<PremiumLayout><AboutPage /></PremiumLayout>} />
      <Route path="/services" element={<PremiumLayout><ServicesPage /></PremiumLayout>} />
      <Route path="/gallery" element={<PremiumLayout><PublicGalleryPage /></PremiumLayout>} />
      <Route path="/contact" element={<PremiumLayout><ContactPage /></PremiumLayout>} />
      <Route path="/login" element={<PremiumLayout><LoginPage /></PremiumLayout>} />

      <Route element={<AppShell />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/create" element={<CreateOrderPage />} />
        <Route path="/orders/:orderId" element={<OrderDetailPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/tasks/:taskId/edit" element={<EditTaskPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        <Route path="/dashboard/gallery" element={<GalleryPage />} />
        <Route path="/stock" element={<StockPage />} />
        <Route path="/expenses" element={<ExpensesPage />} />
        <Route path="/expense-history" element={<ExpenseHistoryPage />} />
        <Route path="/contact-submissions" element={<ContactSubmissionsPage />} />
        <Route path="/todo" element={<TodoPage />} />
        <Route path="/reports" element={<ReportsPage />} />
      </Route>

      {/* 404 Not Found - Must be last */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
